export default "The server can be accessed through `dekluis.ddns.net`";